import styled from '@emotion/styled'

// Define a styled container for the radio button component
export interface RadioButtonContainerProps {
  checked: boolean
  disabled?: boolean
  hasBorder?: boolean
  isEmbedded?: boolean
}

/**
 * An importable RadioButtonContainer, used to create customized radio buttons
 */
const RadioButtonContainer = styled.label<RadioButtonContainerProps>`
  ${({ isEmbedded }) =>
    !isEmbedded
      ? `
  width: auto;
  `
      : 'width: 100%;'}

  ${({ hasBorder }) =>
    hasBorder
      ? `
  padding: 24px 8px;
  border-radius: 8px;
  border: 2px solid #ebeaea;
  `
      : ''}
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;

  /* Customize the text color based on checked and disabled states */
  color: ${(props) => (props.disabled ? '#999999' : props.checked ? '#111111' : '#333333')};

  /* Style the child label element */
  label {
    padding: 2px 0;
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  }
`

export default RadioButtonContainer
